import React from 'react'

const Error = () => {
  return (
    <div>
        <h1>Sorry for the trouble</h1>
        <h2>It will be corrected soon</h2>
    </div>
  )
}

export default Error